import { A11y, Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperNavButtons from "../sliderButtons/SwiperNavButton";
import { useNavigate } from "react-router-dom";
import { getOutsideID } from "../../store/slices/IdSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

interface Visa {
  Recordid: number;
  heading: string;
  price: number;
  text: string;
  urlslug: string;
  SubServiceid: string;
}

interface Props {
  visaData: Visa[];
}

const TouristVisaSlider: React.FC<Props> = ({ visaData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleButton = (footerOutsideId: string, slug: string) => {
    dispatch(getOutsideID({ footerOutsideId }));
    navigate(`/services/${slug}`);
  };

  useEffect(() => {
    import('./touristVisa.css')
  },[])
  
  return (
    <div>
      <div className="">
        <Swiper
          modules={[Navigation, Pagination, A11y, Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          autoplay={{
            // Set autoplay configuration
            delay: 2500, // Duration for each slide (in milliseconds)
            disableOnInteraction: false, // Continue autoplay after user interaction
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 40,
            },

            768: {
              slidesPerView: 1,
              spaceBetween: 4,
            },
            770: {
              slidesPerView: 2,
              spaceBetween: 4,
            },

            1400: {
              slidesPerView: 3,
              spaceBetween: 5,
            },
          }}
        >
          <div className="tourist-vis-slider animate__zoomIn">
            {visaData.map((visa) => (
              <SwiperSlide className="bg-transparent" key={visa.Recordid}>
                <div className="item mr-3">
                  <div className="tourist-card wow animate__zoomIn">
                    <h3>{visa.heading}</h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: visa.text ?? "<p>Content not available</p>",
                      }}
                    />
                    <div>
                      <div className="badge">
                        <div>AED</div>
                        <div className="badgeRight">
                          <span>{visa.price}</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        className="tourist-card-btn"
                        onClick={() =>
                          handleButton(visa.SubServiceid, visa.urlslug)
                        }
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </div>
          <SwiperNavButtons />
        </Swiper>
      </div>
    </div>
  );
};

export default TouristVisaSlider;
